<template>
    <div>
        <div class="card mb-3">
            <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
                <div class="col-md-4" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <h3 class="col card-title pt-1">My Apps</h3>
                        </div>
                        <div class="row">
                            <div class="col p-0 mb-1"><a-input-search placeholder="Search" style="width: 100%" @search="onSearch" /></div> 
                        </div>
                        <div class="row">
                            <div v-if="ownedWavelets.length > 0" class="col p-0">
                                <a-table rowKey="id" :pagination="{pageSize: 7}" size="middle" :showHeader='false' :columns="ownedWaveletColumns" :data-source="ownedWavelets">
                                    <template slot="info" slot-scope="text, record">
                                        <span span>{{record.name | truncate(30, '...')}}</span> <br>
                                        <small>{{record.description | truncate(30, '...')}}</small> <br>
                                        <small>Author: {{record.developer_account_name | truncate(30, '...')}}</small>
                                    </template>
                                    <template slot="action" slot-scope="text, record">
                                        <div class='d-flex justify-content-end align-items-center'>
                                            <button @click="openAccountWebWavelet(record)" class='btn btn-sm btn-primary' type="primary">Open</button>
                                        </div>
                                    </template>
                                </a-table>
                            </div>
                            <div v-else class='col'>
                                <hr class="mt-0 mb-3">
                                <small>No web wavelets found</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8">
                    <div v-if='currentWavelet' class="card-body">
                        <div class="row">
                            <h3 class="col-md-6 card-title fix-overflow">{{currentWavelet.name}}</h3>
                            <div class="col-md-6">
                                <button class='float-right mx-1 btn btn-sm btn-success' type="primary" @click.prevent="showOptionsDrawer">Devices</button>
                                <button class='float-right mx-1 btn btn-sm btn-danger' type="primary" @click.prevent="uninstall">Uninstall</button>
                                <!-- <button v-if='lynexusIntegration != undefined' class='float-right mx-1 btn btn-sm btn-success' type="primary" @click="lynexusConnect" :disabled='lynexusIntegrationDisabled'>Lynexus Connect</button> -->
                            </div>
                            <div class="col-md-12">
                                {{currentWavelet.description}} <br/>
                                <small>By: {{currentWavelet.developer_account_name}}</small>
                                <!-- <hr class="my-3">
                                Devices: -->
                            </div>
                        </div>    
                    </div>
                    <div v-else class="card-body">
                        <a-empty class='mt-5' :image-style="{height: '50px',}" >
                            <span slot="description"> Please select a wavelet </span>
                        </a-empty>
                    </div>
                </div>
            </div>
        </div>
        <a-drawer
            v-if='currentWavelet'
            width="550"
            :visible="optionsDrawerVisible"
            @close="onOptionsDrawerClose"
            :key="componentKey"
            >
                <app-purchase-form @closeDrawer="closeDrawer" :key="componentKey" :updateMode='true' :closeDrawer='closeDrawer'></app-purchase-form>
        </a-drawer> 
    </div>

</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import AppPurchaseForm from './AppPurchaseForm.vue'
    import axios from "axios";
    import { mapState, mapActions } from 'vuex'
    var component_x;
    import DynamicForm from './../DynamicForm.vue'

    export default {
        components:{
            DynamicForm, AppPurchaseForm
        },
        mounted: async function(){  
            component_x = this;
            this.retrieveOwnedWavelets();
        },
        filters: {
            truncate: function (text, length, suffix) {
                if (text.length > length){
                    return text.substring(0, length) + suffix;
                }else {
                    return text
                }
            },
        },
        computed: {
            ...mapState(['endPoint']),
        },
        data() {
          return {
            fetching: false,
            ownedWaveletColumns: [{scopedSlots: { customRender: 'info' }},{scopedSlots: { customRender: 'action' }}],
            ownedWavelets: [],
            currentWavelet: null,
            tabDefaultActiveKey: 1,
            activeTab: "3",
            refreshKey: 0,
            additionalConfiguration: null,
            hasAdditionalConfiguration: false,
            authentication: null,
            hasAuthentication: false,
            authentication_username: null,
            authentication_password: null,
            lockIcon: "unlock",
            authenticationToken: null,
            authenticationRefreshToken: null,
            configuration: null,
            optionsDrawerVisible: false,
            componentKey: 0,
            currentAccountWebWavelet: null,
            currentAccountPosWavelet: null,
            dynamicData: {},
            lynexusIntegration: {},
            lynexusIntegrationDisabled: true,
            currentWaveletAppKey: null,
            currentWaveletAppSecret: null,
            hasIntegratedLynexus: false,
            lynexusIntegrationJson: null,
          }
        },
        methods: {
            ...mapActions(['updateSelectedWavelet']),
            async retrieveOwnedWavelets(){
                var ownedWavelets = []
                ownedWavelets = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets/owned?mobile=1', null)
                this.ownedWavelets = ownedWavelets
            },
            async onSearch(value){
                var ownedWavelets = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets/owned?mobile=1&name='+value, null)
                this.ownedWavelets = ownedWavelets
            },
            async openAccountWebWavelet(record){
                this.currentWavelet = record
                this.authentication = null
                this.additionalConfiguration = null
                this.currentAccountWebWavelet = null
                this.currentAccountPosWavelet = null
                
                this.authentication_username = null
                this.authentication_password = null
                this.lockIcon = 'unlock'
                this.authenticationToken = null
            },
            async updateSettings(formSettings){
                this.additionalConfigurationData = formSettings
            },
            openRedirectLink(){
                var additionalParams = '&'
                if (this.additionalConfigurationData != null){
                    var objectLength = Object.keys(this.additionalConfigurationData).length
                    var counter = 1
                    for (let [key, value] of Object.entries(this.additionalConfigurationData)) {                        
                        additionalParams += key
                        additionalParams += '='
                        additionalParams += value
                        counter++
                        if (counter <= objectLength){
                            additionalParams += '&'
                        }
                    }          
                }
                window.open(this.configuration.redirect_link+"?token="+this.authenticationToken+additionalParams,this.currentSelectedAccountWebWaveletName);
            },
            async showOptionsDrawer(){
                this.componentKey++
                this.optionsDrawerVisible = true;
                this.updateSelectedWavelet(this.currentWavelet)
            },
            closeDrawer(){
                this.onOptionsDrawerClose();
            },
            onOptionsDrawerClose(){
                this.componentKey++
                this.optionsDrawerVisible = false;
            },
           
            async uninstall(){
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'account_app_wavelets/'+this.currentWavelet.id+'/uninstall', null, null)
                    if (post_request.message == 'success'){
                        this.$notification['success']({
                                message: 'App is successfully uninstalled',
                        });
                        this.retrieveOwnedWavelets()
                        this.currentWavelet = null
                    }
            },

        }
    }
</script>

<style>

</style>


